baseApp.service('TimeZoneService', ['$window', function($window){
    var CURRENT_TIMEZONE_KEY = 'currentTimeZone';
    var NO_TIMEZONE_FORMAT = 'YYYY-MM-DD HH:mm:ss:SSS';
    var serviceInstance = {};
    var localTimeZone = moment.tz.guess();
    var currentTimeZone = $window.localStorage.getItem(CURRENT_TIMEZONE_KEY) || localTimeZone;
    moment.tz.setDefault(currentTimeZone);
    var timeZones;


    serviceInstance.convertFromTo = function(date, from, to) {
        if(!from || !to || from == to) {
            return date;
        }
        if(date instanceof Date) {
            date = date.getTime();
        }
        var fromOffset = moment.tz.zone(from).utcOffset(date);
        var toOffset = moment.tz.zone(to).utcOffset(date);
        return new Date(date + (toOffset - fromOffset) * 60000).getTime();
    }

    serviceInstance.convertToLocal = function(date, force) {
        if(!date) {
            return date;
        }
        if(!force && currentTimeZone == localTimeZone) {
            return date;
        } else {
            return serviceInstance.convertFromTo(date, currentTimeZone, localTimeZone);
        }
    }

    serviceInstance.convertToCurrent = function(date) {
        if(!date) {
            return date;
        } else {
            return serviceInstance.convertFromTo(date, localTimeZone, currentTimeZone);
        }
    }

    serviceInstance.chartCategoryFunction = function(value, dataItem, category) {
        return new Date(serviceInstance.convertToLocal(value));
    }

    serviceInstance.getCurrentTimeZoneOffset = function() {
        return moment.tz(currentTimeZone).format('Z');
    }

    serviceInstance.getCurrentTimeZone = function() {
        return currentTimeZone;
    }

    serviceInstance.setCurrentTimeZone = function(timeZone) {
        if(timeZone) {
            currentTimeZone = timeZone;
            $window.localStorage.setItem(CURRENT_TIMEZONE_KEY, timeZone);
            moment.tz.setDefault(timeZone);
        }
    };

    serviceInstance.getTimeZones = function(cb){
        if(timeZones) {
            cb(timeZones);
        } else {
            store.fetch({
                path: '/timezones',
                success: function(data) {
                    timeZones = data;
                    cb(timeZones);
                }
            });
        }
    };


    return serviceInstance;
}]);